// extracted by mini-css-extract-plugin
export default {"cutoff":"cutoff_cutoff__ekrf-"};